import { IPrice, Price } from "./Price";

export interface IGrouping {
    availabilityEndDate: Date | undefined;
    availabilityStartDate: Date | undefined;
    countries: string | undefined;
    createdBy: string | undefined;
    createdByName: string | undefined;
    creationdDate: Date | undefined;
    elecFixedPeriodDays?: number;
    elecSupplyStartDateFrom?: Date | undefined;
    elecSupplyStartDateTo?: Date | undefined;
    forElectricity: boolean;
    forNaturalGas: boolean;
    id: string | undefined;
    internalCode: string | undefined;
    isElecFixedTermContract: boolean;
    isExclusive: boolean;
    isNtrlGasFixedTermContract: boolean;
    ntrlGasFixedPeriodDays?: number;
    ntrlGasSupplyStartDateFrom?: Date | undefined;
    ntrlGasSupplyStartDateTo?: Date | undefined;
    status: string | undefined;
    supplierName: string | undefined;

    prices: IPrice[];
}

export class Grouping implements IGrouping {

    availabilityEndDate: Date | undefined;
    availabilityStartDate: Date | undefined;
    countries: string | undefined;
    createdBy: string | undefined;
    createdByName: string | undefined;
    creationdDate: Date | undefined;
    elecFixedPeriodDays?: number | undefined;
    elecSupplyStartDateFrom?: Date | undefined;
    elecSupplyStartDateTo?: Date | undefined;
    forElectricity: boolean = false;
    forNaturalGas: boolean = false;
    id: string | undefined;
    internalCode: string | undefined;
    isElecFixedTermContract: boolean = false;
    isExclusive: boolean = false;
    isNtrlGasFixedTermContract: boolean = false;
    ntrlGasFixedPeriodDays?: number | undefined;
    ntrlGasSupplyStartDateFrom?: Date | undefined;
    ntrlGasSupplyStartDateTo?: Date | undefined;
    status: string | undefined;
    supplierName: string | undefined;
    prices: IPrice[] = [];
    
    constructor(groupingParams: Partial<IGrouping>) {

        if (groupingParams.availabilityEndDate) {
            groupingParams.availabilityEndDate = new Date(groupingParams.availabilityEndDate);
        }
        
        if (groupingParams.availabilityStartDate) {
            groupingParams.availabilityStartDate = new Date(groupingParams.availabilityStartDate);
        }
        
        if (groupingParams.elecSupplyStartDateFrom) {
            groupingParams.elecSupplyStartDateFrom = new Date(groupingParams.elecSupplyStartDateFrom);
        }
        
        if (groupingParams.elecSupplyStartDateTo) {
            groupingParams.elecSupplyStartDateTo = new Date(groupingParams.elecSupplyStartDateTo);
        }

        if (groupingParams.ntrlGasSupplyStartDateFrom) {
            groupingParams.ntrlGasSupplyStartDateFrom = new Date(groupingParams.ntrlGasSupplyStartDateFrom);
        }

        if (groupingParams.ntrlGasSupplyStartDateTo) {
            groupingParams.ntrlGasSupplyStartDateTo = new Date(groupingParams.ntrlGasSupplyStartDateTo);
        }

        Object.assign(this, groupingParams);
    }
}

export class CreateElectricityGrouping {

    groupingPricesIds: string[];
    contractTypeId: string;
    electricityMeterId?: number;
    energyOpportunityElectricityMeterId?: string;
    groupingId?: string;

    constructor(
        groupingPricesIds: string[],
        contractTypeId: string,
        electricityMeterId?: number,
        energyOpportunityElectricityMeterId?: string,
        groupingId?: string
    ) {
        this.groupingPricesIds = groupingPricesIds;
        this.contractTypeId = contractTypeId;
        this.electricityMeterId = electricityMeterId;
        this.energyOpportunityElectricityMeterId = energyOpportunityElectricityMeterId;
        this.groupingId = groupingId;
    }

}

export class CreateNaturalGasGrouping {

    groupingPricesIds: string[];
    contractTypeId: string;
    naturalGasMeterId?: number;
    energyOpportunityNaturalGasMeterId?: string;
    groupingId?: string;
    
    constructor(
        groupingPricesIds: string[],
        contractTypeId: string,
        naturalGasMeterId?: number,
        energyOpportunityNaturalGasMeterId?: string,
        groupingId?: string
    ) {
        this.groupingPricesIds = groupingPricesIds;
        this.contractTypeId = contractTypeId;
        this.naturalGasMeterId = naturalGasMeterId;
        this.energyOpportunityNaturalGasMeterId = energyOpportunityNaturalGasMeterId;
        this.groupingId = groupingId;
    }

}